export default "__VITE_ASSET__Cv3g97ii__"